
import NotesUtil from '../../helpers/NotesUtil'

describe('NotesUtil', () => {
  let result
  describe('#gotoTab', () => {
    let event
    beforeAll(() => {
      event = { target: { getAttribute: () => 'financial_review' }, preventDefault: jest.fn() }
      const div = document.createElement('a');
      div.setAttribute('id', 'financial_review');
      document.body.appendChild(div);
    })
    it('should call fnc', () => {
      const mockAnchorClick = jest.fn();
      document.getElementById('financial_review').click = mockAnchorClick
      NotesUtil.gotoTab(event)
      expect(mockAnchorClick).toHaveBeenCalled();
    })
    it('should not call fnc', () => {
      Object.defineProperty(document, 'getElementById', {
        value: () => null
      });
      NotesUtil.gotoTab(event)
      expect(result).toBeFalsy()
    })
  })

  describe('#getAdminAcronym', () => {
    it('should return acronym of passed string function', () => {
      const name = 'SmartBiz Admin'
      expect(NotesUtil.getAdminAcronym({ name })).toEqual("SA")
      expect(NotesUtil.getAdminAcronym({})).toEqual("N/A")
    })
  })

  describe('#getQuestionTitle', () => {
    it('should return acronym of passed string function', () => {
      const name = 'SmartBiz Admin'
      const createdAt = '2019-12-02'
      expect(NotesUtil.getAdminNameAndDate({ name, createdAt })).toEqual("SmartBiz Admin    2019-12-02")
    })
  })
  describe('#getAccessText', () => {
    it('should return accessText based the bankUser admin or not', () => {
      let isBankUser = true
      expect(NotesUtil.getAccessText(isBankUser)).toEqual("Bank Viewable only")
      isBankUser = false
      expect(NotesUtil.getAccessText(isBankUser)).toEqual("SmartBiz Viewable only")
    })
  })
  describe('#getEditorTitle', () => {
    it('should return editor title based question workflow and topic draft state', () => {
      expect(NotesUtil.getEditorTitle('new_question', false)).toEqual("Question")
      expect(NotesUtil.getEditorTitle('reply_question', false)).toEqual("Reply")
      expect(NotesUtil.getEditorTitle('edit_reply', false)).toEqual("Reply")
      expect(NotesUtil.getEditorTitle('edit_question', false)).toEqual("Edit")
      expect(NotesUtil.getEditorTitle('', true)).toEqual("Edit Draft")
      expect(NotesUtil.getEditorTitle('', false)).toEqual("Topic & Explanation")
    })
  })
  describe('#getPlaceholderText', () => {
    it('should return placeholder text based question state', () => {
      expect(NotesUtil.getPlaceholderText('new_question')).toEqual("Type your question here")
      expect(NotesUtil.getPlaceholderText('reply_question')).toEqual("Type your reply here")
      expect(NotesUtil.getPlaceholderText('edit_reply')).toEqual("Type your reply here")
      expect(NotesUtil.getPlaceholderText('edit_question')).toEqual("Type your question here")
      expect(NotesUtil.getPlaceholderText('')).toEqual("Type your topic here")
    })
  })
  describe('#hideEditorTitle', () => {
    it('should hide the title for question workflow and show for topic workflow', () => {
      expect(NotesUtil.hideEditorTitle('new_question')).toBeTruthy()
      expect(NotesUtil.hideEditorTitle('')).toBeFalsy()
    })
  })
  describe('#customBlockStyleFn', () => {
    it('should return newParagraph', () => {
      const contentBlock = {
        type: 'unstyled', 
        getType: () => 'unstyled'
      }
      expect(NotesUtil.customBlockStyleFn(contentBlock)).toEqual('newParagraph')
    })
  },
  describe('#getTooltipBottomEdge', () => {
    it('should return the bottomEdge number based on the tooltip text', () => {
      let tooltipText = 'URL link to website if applicable'
      expect(NotesUtil.getTooltipBottomEdge(tooltipText)).toEqual(13)
      tooltipText = 'This section should include any clarification of the financial statements that is necessary to understanding the credit story. For example, commentary on Accounts Receivable if it is significantly high in comparison to revenue or clarification on Other Liabilities if significant.'
      expect(NotesUtil.getTooltipBottomEdge(tooltipText)).toEqual(48)
    })
  }))
})